"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _StagedObject = _interopRequireDefault(require("redux-less/StagedObject"));

var _constants = require("settings-ui-sdk/SiteSettings/constants");

var _selectors = require("settings-ui-sdk/SiteSettings/selectors");

var properties = [_constants.BACKGROUND_COLOR, _constants.BODY_BORDER_COLOR, _constants.BODY_BORDER_COLOR_CHOICE, _constants.BODY_COLOR, _constants.COLOR_PICKER_FAVORITE_1, _constants.COLOR_PICKER_FAVORITE_2, _constants.COLOR_PICKER_FAVORITE_3, _constants.COLOR_PICKER_FAVORITE_4, _constants.COLOR_PICKER_FAVORITE_5, _constants.COLOR_PICKER_FAVORITE_6, _constants.CUSTOM_SUBSCRIPTION_CONFIRMATION, _constants.CUSTOM_SUBSCRIPTION_PREFERENCES, _constants.CUSTOM_UNSUBSCRIBE_SIMPLE, _constants.EMAIL_BODY_PADDING, _constants.EMAIL_BODY_WIDTH, _constants.EMAIL_OPTIN_CONFIRMATION_PAGE_ID, _constants.EMAIL_RESUBSCRIBE_ENABLED, _constants.EMAIL_RSS_DATE_FORMAT, _constants.EMAIL_RSS_DATE_LANGUAGE, _constants.GRAYMAIL_SUPPRESSION_ENABLED_BY_DEFAULT, _constants.PRIMARY_ACCENT_COLOR, _constants.PRIMARY_FONT, _constants.PRIMARY_FONT_COLOR, _constants.PRIMARY_FONT_SIZE, _constants.SECONDARY_ACCENT_COLOR, _constants.SECONDARY_FONT, _constants.SECONDARY_FONT_COLOR, _constants.SECONDARY_FONT_SIZE, _constants.UTM_AUTOMATIC_PLAIN_TEXT_TRACKING, _constants.UTM_AUTOMATIC_TRACKING, _constants.UTM_IDENTITY_TRACKING, _constants.UTM_SOURCE_TRACKING];
var UpdateEmailSiteSettings = new _StagedObject.default({
  domainSelector: _selectors.getAllDomainsSiteSettings,
  stagedSelector: function stagedSelector(state) {
    return state.modules.marketing.email.staging.updateEmailSiteSettings;
  },
  namespace: 'email',
  objectType: 'SiteSettings',
  properties: properties
});
var _default = UpdateEmailSiteSettings;
exports.default = _default;
module.exports = exports.default;